import React from "react";
import { MdClose } from "react-icons/md";

const CloseButton = ({ closeBtn }) => {
  return (
    <span
      className="modal-close-btn flex-center color-black"
      onClick={closeBtn}
    >
      <MdClose />
    </span>
  );
};

export default CloseButton;
